export const formatContextVariables = (
  contextVariables: Record<string, string>,
) => {
  const cvNames = Object.keys(contextVariables);

  const nameNValue = cvNames.map(cvName => {
    return `$${cvName} (${contextVariables[cvName]})`;
  });

  return nameNValue.join(', ');
};

export const formatTimeSpent = (seconds: number, shortFormat = false) => {
  if (seconds === 0) {
    return shortFormat ? '0s' : '0 sec';
  }

  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor((seconds % 3600) % 60);

  if (shortFormat) {
    const hDisplay = h > 0 ? `${h}h` : '';
    const mDisplay = m > 0 ? `${m}m` : '';
    const sDisplay = s > 0 ? `${s}s` : '';

    if (h > 100) {
      return hDisplay + mDisplay;
    }

    return hDisplay + mDisplay + sDisplay;
  }

  const hDisplay = h > 0 ? h + ' hr' : '';
  const mDisplay = m > 0 ? m + ' min' : '';
  const sDisplay = s > 0 ? s + ' sec' : '';

  if (h > 100) {
    return [hDisplay, mDisplay].filter(Boolean).join(' ');
  }

  return [hDisplay, mDisplay, sDisplay].filter(Boolean).join(' ');
};
